module.exports = __webpack_public_path__ + "static/img/wine_capsule.e3e7d772.gif";